<div class="section-tab">
  <app-installation-report-object-header
    [address]="address()"
    [isNotApplicable]="state().notApplicable"
  />

  <app-section-not-applicable
    [state]="state()"
    [isSaving]="isNotApplicableSaving()"
    [(isEnteringReason)]="isEnteringNotApplicableReason"
    (changed)="notApplicableChanged.emit($event)"
  />

  @if (showSectionContent()) {
    <div class="content-container">
      @if (hasLeftColumn()) {
        <div class="left-column">
          @if (config().hasSigning) {
            <app-building-signing-card
              [isReadyForSigning]="isReadyForSigning()"
              [contact]="contact()"
              [signing]="state().signing"
              (startSigning)="signingStarted.emit()"
            />
          }
          @if (config().id === 'PRE_INSTALLATION') {
            <gc-input-field
              [label]="
                'installationReportV2.preinstallationTab.macAddressInputLabel'
                  | translate
              "
              [placeholder]="
                'installationReportV2.preinstallationTab.macSerialPlaceholder'
                  | translate
              "
              [value]="state().macAddress ?? ''"
              (changed)="onMacAddress($event)"
            />
          }
          @if (
            showConnectionStatus() && config().id === 'COMMISSION' && accessId()
          ) {
            <app-port-connection-status-container
              [accessId]="accessId()"
              [macAddress]="preInstallationMacAddress()"
              (navigateToPreinstallation)="navigateToPreinstallation.emit()"
            />
          }
          @if (config().items.length) {
            <app-self-inspection-section
              [sectionTitleKey]="config().tabNameKey"
              [items]="config().items"
              [state]="state()"
              [mutationLoadingState]="mutationLoadingState()"
              (toggleShowControlled)="onShowControlled($event)"
              (markDone)="onMarkDone($event)"
              (markNotApplicable)="onMarkNotApplicable($event)"
              (uploadFiles)="onUploadFiles($event)"
              (undo)="onUndo($event)"
              (viewAttachments)="selfInspectionAttachmentsViewed.emit($event)"
            />
          }
          @if (config().hasFiberData) {
            <app-installation-report-fiber-data-form
              [fiberData]="state().fiberData"
              [usesPanelCard]="state().usesPanelCard"
              (panelcardChanged)="onPanelcardChanged($event)"
              (fieldChanged)="onFiberField($event)"
            />
          }
        </div>
        <div class="divider"></div>
      }

      <div class="right-column">
        <app-section-sidebar
          [config]="config()"
          [sectionState]="state()"
          [canMarkNotApplicable]="canMarkNotApplicable()"
          (plannedDateChanged)="onPlannedDate($event)"
          (completedDateChanged)="onCompletedDate($event)"
          (commentChanged)="onComment($event)"
          (checklistChanged)="onChecklist($event)"
          (filesChanged)="onFiles($event)"
          (markNotApplicableClicked)="isEnteringNotApplicableReason.set(true)"
        />
      </div>
    </div>
  }
</div>
